import React from 'react'
import { Grid, Card, CardContent } from '@mui/material'
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined'
import SearchIcon from '@mui/icons-material/Search'
import { useStyle } from './style'

const CardSelection = ({ onNewCustomer, onExistingCustomer }) => {
  const classes = useStyle()

  return (
    <div className={classes.selectionWrapper}>
      <h2 className={classes.title}>Create New Policy</h2>
      <p className={classes.subtitle}>Choose how you want to proceed</p>
      <Grid container spacing={3} style={{ marginTop: '20px' }}>
        <Grid item xs={12} sm={12} md={6}>
          <Card
            className={classes.card}
            onClick={onNewCustomer}
            style={{ cursor: 'pointer' }}
          >
            <CardContent className={classes.cardContent}>
              <HowToRegOutlinedIcon className={classes.icon} />
              <h3>New Customer</h3>
              <p>Register a new customer and create their policy</p>
              <button className={classes.button}>Register New Customer</button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Card
            className={classes.card}
            onClick={onExistingCustomer}
            style={{ cursor: 'pointer' }}
          >
            <CardContent className={classes.cardContent}>
              <SearchIcon className={classes.icon} />
              <h3>Existing Customer</h3>
              <p>Search for an existing customer and create their policy</p>
              <button className={classes.button}>Search Customer</button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  )
}

export default CardSelection
